import dataSelect from '@store/dataForSelect/reducers';

import { options_category_select } from '../../configs/constants';

export default dataSelect(options_category_select);
